const parseError = function (message) {
    throw Error(`Parse error: ${message}`);
};
export default parseError;
//# sourceMappingURL=parse-error.js.map